import { ChangeEvent, useEffect, useState } from 'react';

import { useDebounce } from '@hooks/useDebounce';

import { useGetMyProfileQuery, useInfiniteLoaderUserQueryQuery } from '@redux/api/user';

import { SEARCH_DEBOUNCE_MS, USERS_PER_PAGE } from '../../constants';

export const useUserList = ({ filters = {}, skipRequest = false, filterOwner = false }) => {
  const [pageNumber, setPageNumber] = useState(0);
  const [search, setSearch] = useState('');
  const searchDebounce = useDebounce(search, SEARCH_DEBOUNCE_MS);

  const { data: currentUser } = useGetMyProfileQuery();
  const { data, isLoading, isFetching } = useInfiniteLoaderUserQueryQuery(
    {
      PageNumber: pageNumber,
      ItemsPerPage: USERS_PER_PAGE,
      SearchText: searchDebounce.trim(),
      UserStatus: 1,
      UserRole: 'Recipient',
      ExcludeUserIds: filterOwner ? [currentUser?.id || ''] : [],
      ...filters,
    },
    { skip: skipRequest, refetchOnMountOrArgChange: true },
  );

  const items = data?.items || [];

  const loadNextPage = () => {
    if (!isFetching && data?.hasNextPage) {
      setPageNumber(pageNumber + 1);
    }
    return Promise.resolve();
  };

  useEffect(() => {
    setPageNumber(0);
  }, [searchDebounce]);

  const isItemLoaded = (index: number) => !data?.hasNextPage || index < items.length;

  const onSearch = (event: ChangeEvent<HTMLInputElement>) => setSearch(event.target.value);

  return {
    items,
    searchDebounce,
    data,
    isLoading,
    isFetching,
    loadNextPage,
    isItemLoaded,
    onSearch,
    search,
  };
};
